<div class="uk-section uk-animation-slide-bottom-small" uk-parallax="opacity: 1,0">
  <div class="uk-container">
    <p>
      I am a Software Engineer with more than 3 years of experience in the industry. I am currently working in
      ML-powered Search in Office 365's team in London.
      My passions include but are not limited to:
    </p>
    <ul>
      <li>Machine Learning</li>
      <li>Distributed and scalable architectures</li>
      <li>Web technologies</li>
      <li>Accessibility and inclusive UX</li>
    </ul>
  </div>
</div>